export const countries = [
    {
        id: "AF",
        name: {
            en: "Afghanistan",
            de: "Afghanistan",
        },
    },
    {
        id: "AX",
        name: {
            en: "Åland Islands",
            de: "Åland",
        },
    },
    {
        id: "AL",
        name: {
            en: "Albania",
            de: "Albanien",
        },
    },
    {
        id: "DZ",
        name: {
            en: "Algeria",
            de: "Algerien",
        },
    },
    {
        id: "AS",
        name: {
            en: "American Samoa",
            de: "Amerikanisch-Samoa",
        },
    },
    {
        id: "AD",
        name: {
            en: "Andorra",
            de: "Andorra",
        },
    },
    {
        id: "AO",
        name: {
            en: "Angola",
            de: "Angola",
        },
    },
    {
        id: "AI",
        name: {
            en: "Anguilla",
            de: "Anguilla",
        },
    },
    {
        id: "AQ",
        name: {
            en: "Antarctica",
            de: "Antarktis",
        },
    },
    {
        id: "AG",
        name: {
            en: "Antigua and Barbuda",
            de: "Antigua und Barbuda",
        },
    },
    {
        id: "AR",
        name: {
            en: "Argentina",
            de: "Argentinien",
        },
    },
    {
        id: "AM",
        name: {
            en: "Armenia",
            de: "Armenien",
        },
    },
    {
        id: "AW",
        name: {
            en: "Aruba",
            de: "Aruba",
        },
    },
    {
        id: "AU",
        name: {
            en: "Australia",
            de: "Australien",
        },
    },
    {
        id: "AT",
        name: {
            en: "Austria",
            de: "Österreich",
        },
    },
    {
        id: "AZ",
        name: {
            en: "Azerbaijan",
            de: "Aserbaidschan",
        },
    },
    {
        id: "BS",
        name: {
            en: "Bahamas",
            de: "Bahamas",
        },
    },
    {
        id: "BH",
        name: {
            en: "Bahrain",
            de: "Bahrain",
        },
    },
    {
        id: "BD",
        name: {
            en: "Bangladesh",
            de: "Bangladesch",
        },
    },
    {
        id: "BB",
        name: {
            en: "Barbados",
            de: "Barbados",
        },
    },
    {
        id: "BY",
        name: {
            en: "Belarus",
            de: "Weißrussland",
        },
    },
    {
        id: "BE",
        name: {
            en: "Belgium",
            de: "Belgien",
        },
    },
    {
        id: "BZ",
        name: {
            en: "Belize",
            de: "Belize",
        },
    },
    {
        id: "BJ",
        name: {
            en: "Benin",
            de: "Benin",
        },
    },
    {
        id: "BM",
        name: {
            en: "Bermuda",
            de: "Bermuda",
        },
    },
    {
        id: "BT",
        name: {
            en: "Bhutan",
            de: "Bhutan",
        },
    },
    {
        id: "BO",
        name: {
            en: "Bolivia",
            de: "Bolivien",
        },
    },
    {
        id: "BA",
        name: {
            en: "Bosnia and Herzegovina",
            de: "Bosnien und Herzegowina",
        },
    },
    {
        id: "BW",
        name: {
            en: "Botswana",
            de: "Botswana",
        },
    },
    {
        id: "BV",
        name: {
            en: "Bouvet Island",
            de: "Bouvetinsel",
        },
    },
    {
        id: "BR",
        name: {
            en: "Brazil",
            de: "Brasilien",
        },
    },
    {
        id: "IO",
        name: {
            en: "British Indian Ocean Territory",
            de: "Britisches Territorium im Indischen Ozean",
        },
    },
    {
        id: "VG",
        name: {
            en: "British Virgin Islands",
            de: "Britische Jungferninseln",
        },
    },
    {
        id: "BN",
        name: {
            en: "Brunei",
            de: "Brunei",
        },
    },
    {
        id: "BG",
        name: {
            en: "Bulgaria",
            de: "Bulgarien",
        },
    },
    {
        id: "BF",
        name: {
            en: "Burkina Faso",
            de: "Burkina Faso",
        },
    },
    {
        id: "BI",
        name: {
            en: "Burundi",
            de: "Burundi",
        },
    },
    {
        id: "KH",
        name: {
            en: "Cambodia",
            de: "Kambodscha",
        },
    },
    {
        id: "CM",
        name: {
            en: "Cameroon",
            de: "Kamerun",
        },
    },
    {
        id: "CA",
        name: {
            en: "Canada",
            de: "Kanada",
        },
    },
    {
        id: "CV",
        name: {
            en: "Cape Verde",
            de: "Kap Verde",
        },
    },
    {
        id: "BQ",
        name: {
            en: "Caribbean Netherlands",
            de: "Karibische Niederlande",
        },
    },
    {
        id: "KY",
        name: {
            en: "Cayman Islands",
            de: "Kaimaninseln",
        },
    },
    {
        id: "CF",
        name: {
            en: "Central African Republic",
            de: "Zentralafrikanische Republik",
        },
    },
    {
        id: "TD",
        name: {
            en: "Chad",
            de: "Tschad",
        },
    },
    {
        id: "CL",
        name: {
            en: "Chile",
            de: "Chile",
        },
    },
    {
        id: "CN",
        name: {
            en: "China",
            de: "China",
        },
    },
    {
        id: "CX",
        name: {
            en: "Christmas Island",
            de: "Weihnachtsinsel",
        },
    },
    {
        id: "CC",
        name: {
            en: "Cocos (Keeling) Islands",
            de: "Kokosinseln",
        },
    },
    {
        id: "CO",
        name: {
            en: "Colombia",
            de: "Kolumbien",
        },
    },
    {
        id: "KM",
        name: {
            en: "Comoros",
            de: "Komoren",
        },
    },
    {
        id: "CK",
        name: {
            en: "Cook Islands",
            de: "Cookinseln",
        },
    },
    {
        id: "CR",
        name: {
            en: "Costa Rica",
            de: "Costa Rica",
        },
    },
    {
        id: "HR",
        name: {
            en: "Croatia",
            de: "Kroatien",
        },
    },
    {
        id: "CU",
        name: {
            en: "Cuba",
            de: "Kuba",
        },
    },
    {
        id: "CW",
        name: {
            en: "Curaçao",
            de: "Curaçao",
        },
    },
    {
        id: "CY",
        name: {
            en: "Cyprus",
            de: "Zypern",
        },
    },
    {
        id: "CZ",
        name: {
            en: "Czechia",
            de: "Tschechien",
        },
    },
    {
        id: "DK",
        name: {
            en: "Denmark",
            de: "Dänemark",
        },
    },
    {
        id: "DJ",
        name: {
            en: "Djibouti",
            de: "Dschibuti",
        },
    },
    {
        id: "DM",
        name: {
            en: "Dominica",
            de: "Dominica",
        },
    },
    {
        id: "DO",
        name: {
            en: "Dominican Republic",
            de: "Dominikanische Republik",
        },
    },
    {
        id: "CD",
        name: {
            en: "DR Congo",
            de: "Kongo (Dem. Rep.)",
        },
    },
    {
        id: "EC",
        name: {
            en: "Ecuador",
            de: "Ecuador",
        },
    },
    {
        id: "EG",
        name: {
            en: "Egypt",
            de: "Ägypten",
        },
    },
    {
        id: "SV",
        name: {
            en: "El Salvador",
            de: "El Salvador",
        },
    },
    {
        id: "GQ",
        name: {
            en: "Equatorial Guinea",
            de: "Äquatorialguinea",
        },
    },
    {
        id: "ER",
        name: {
            en: "Eritrea",
            de: "Eritrea",
        },
    },
    {
        id: "EE",
        name: {
            en: "Estonia",
            de: "Estland",
        },
    },
    {
        id: "SZ",
        name: {
            en: "Eswatini",
            de: "Swasiland",
        },
    },
    {
        id: "ET",
        name: {
            en: "Ethiopia",
            de: "Äthiopien",
        },
    },
    {
        id: "FK",
        name: {
            en: "Falkland Islands",
            de: "Falklandinseln",
        },
    },
    {
        id: "FO",
        name: {
            en: "Faroe Islands",
            de: "Färöer-Inseln",
        },
    },
    {
        id: "FJ",
        name: {
            en: "Fiji",
            de: "Fidschi",
        },
    },
    {
        id: "FI",
        name: {
            en: "Finland",
            de: "Finnland",
        },
    },
    {
        id: "FR",
        name: {
            en: "France",
            de: "Frankreich",
        },
    },
    {
        id: "GF",
        name: {
            en: "French Guiana",
            de: "Französisch-Guayana",
        },
    },
    {
        id: "PF",
        name: {
            en: "French Polynesia",
            de: "Französisch-Polynesien",
        },
    },
    {
        id: "TF",
        name: {
            en: "French Southern and Antarctic Lands",
            de: "Französische Süd- und Antarktisgebiete",
        },
    },
    {
        id: "GA",
        name: {
            en: "Gabon",
            de: "Gabun",
        },
    },
    {
        id: "GM",
        name: {
            en: "Gambia",
            de: "Gambia",
        },
    },
    {
        id: "GE",
        name: {
            en: "Georgia",
            de: "Georgien",
        },
    },
    {
        id: "DE",
        name: {
            en: "Germany",
            de: "Deutschland",
        },
    },
    {
        id: "GH",
        name: {
            en: "Ghana",
            de: "Ghana",
        },
    },
    {
        id: "GI",
        name: {
            en: "Gibraltar",
            de: "Gibraltar",
        },
    },
    {
        id: "GR",
        name: {
            en: "Greece",
            de: "Griechenland",
        },
    },
    {
        id: "GL",
        name: {
            en: "Greenland",
            de: "Grönland",
        },
    },
    {
        id: "GD",
        name: {
            en: "Grenada",
            de: "Grenada",
        },
    },
    {
        id: "GP",
        name: {
            en: "Guadeloupe",
            de: "Guadeloupe",
        },
    },
    {
        id: "GU",
        name: {
            en: "Guam",
            de: "Guam",
        },
    },
    {
        id: "GT",
        name: {
            en: "Guatemala",
            de: "Guatemala",
        },
    },
    {
        id: "GG",
        name: {
            en: "Guernsey",
            de: "Guernsey",
        },
    },
    {
        id: "GN",
        name: {
            en: "Guinea",
            de: "Guinea",
        },
    },
    {
        id: "GW",
        name: {
            en: "Guinea-Bissau",
            de: "Guinea-Bissau",
        },
    },
    {
        id: "GY",
        name: {
            en: "Guyana",
            de: "Guyana",
        },
    },
    {
        id: "HT",
        name: {
            en: "Haiti",
            de: "Haiti",
        },
    },
    {
        id: "HM",
        name: {
            en: "Heard Island and McDonald Islands",
            de: "Heard und die McDonaldinseln",
        },
    },
    {
        id: "HN",
        name: {
            en: "Honduras",
            de: "Honduras",
        },
    },
    {
        id: "HK",
        name: {
            en: "Hong Kong",
            de: "Hongkong",
        },
    },
    {
        id: "HU",
        name: {
            en: "Hungary",
            de: "Ungarn",
        },
    },
    {
        id: "IS",
        name: {
            en: "Iceland",
            de: "Island",
        },
    },
    {
        id: "IN",
        name: {
            en: "India",
            de: "Indien",
        },
    },
    {
        id: "ID",
        name: {
            en: "Indonesia",
            de: "Indonesien",
        },
    },
    {
        id: "IR",
        name: {
            en: "Iran",
            de: "Iran",
        },
    },
    {
        id: "IQ",
        name: {
            en: "Iraq",
            de: "Irak",
        },
    },
    {
        id: "IE",
        name: {
            en: "Ireland",
            de: "Irland",
        },
    },
    {
        id: "IM",
        name: {
            en: "Isle of Man",
            de: "Insel Man",
        },
    },
    {
        id: "IL",
        name: {
            en: "Israel",
            de: "Israel",
        },
    },
    {
        id: "IT",
        name: {
            en: "Italy",
            de: "Italien",
        },
    },
    {
        id: "CI",
        name: {
            en: "Ivory Coast",
            de: "Elfenbeinküste",
        },
    },
    {
        id: "JM",
        name: {
            en: "Jamaica",
            de: "Jamaika",
        },
    },
    {
        id: "JP",
        name: {
            en: "Japan",
            de: "Japan",
        },
    },
    {
        id: "JE",
        name: {
            en: "Jersey",
            de: "Jersey",
        },
    },
    {
        id: "JO",
        name: {
            en: "Jordan",
            de: "Jordanien",
        },
    },
    {
        id: "KZ",
        name: {
            en: "Kazakhstan",
            de: "Kasachstan",
        },
    },
    {
        id: "KE",
        name: {
            en: "Kenya",
            de: "Kenia",
        },
    },
    {
        id: "KI",
        name: {
            en: "Kiribati",
            de: "Kiribati",
        },
    },
    {
        id: "XK",
        name: {
            en: "Kosovo",
            de: "Kosovo",
        },
    },
    {
        id: "KW",
        name: {
            en: "Kuwait",
            de: "Kuwait",
        },
    },
    {
        id: "KG",
        name: {
            en: "Kyrgyzstan",
            de: "Kirgisistan",
        },
    },
    {
        id: "LA",
        name: {
            en: "Laos",
            de: "Laos",
        },
    },
    {
        id: "LV",
        name: {
            en: "Latvia",
            de: "Lettland",
        },
    },
    {
        id: "LB",
        name: {
            en: "Lebanon",
            de: "Libanon",
        },
    },
    {
        id: "LS",
        name: {
            en: "Lesotho",
            de: "Lesotho",
        },
    },
    {
        id: "LR",
        name: {
            en: "Liberia",
            de: "Liberia",
        },
    },
    {
        id: "LY",
        name: {
            en: "Libya",
            de: "Libyen",
        },
    },
    {
        id: "LI",
        name: {
            en: "Liechtenstein",
            de: "Liechtenstein",
        },
    },
    {
        id: "LT",
        name: {
            en: "Lithuania",
            de: "Litauen",
        },
    },
    {
        id: "LU",
        name: {
            en: "Luxembourg",
            de: "Luxemburg",
        },
    },
    {
        id: "MO",
        name: {
            en: "Macau",
            de: "Macao",
        },
    },
    {
        id: "MG",
        name: {
            en: "Madagascar",
            de: "Madagaskar",
        },
    },
    {
        id: "MW",
        name: {
            en: "Malawi",
            de: "Malawi",
        },
    },
    {
        id: "MY",
        name: {
            en: "Malaysia",
            de: "Malaysia",
        },
    },
    {
        id: "MV",
        name: {
            en: "Maldives",
            de: "Malediven",
        },
    },
    {
        id: "ML",
        name: {
            en: "Mali",
            de: "Mali",
        },
    },
    {
        id: "MT",
        name: {
            en: "Malta",
            de: "Malta",
        },
    },
    {
        id: "MH",
        name: {
            en: "Marshall Islands",
            de: "Marshallinseln",
        },
    },
    {
        id: "MQ",
        name: {
            en: "Martinique",
            de: "Martinique",
        },
    },
    {
        id: "MR",
        name: {
            en: "Mauritania",
            de: "Mauretanien",
        },
    },
    {
        id: "MU",
        name: {
            en: "Mauritius",
            de: "Mauritius",
        },
    },
    {
        id: "YT",
        name: {
            en: "Mayotte",
            de: "Mayotte",
        },
    },
    {
        id: "MX",
        name: {
            en: "Mexico",
            de: "Mexiko",
        },
    },
    {
        id: "FM",
        name: {
            en: "Micronesia",
            de: "Mikronesien",
        },
    },
    {
        id: "MD",
        name: {
            en: "Moldova",
            de: "Moldawien",
        },
    },
    {
        id: "MC",
        name: {
            en: "Monaco",
            de: "Monaco",
        },
    },
    {
        id: "MN",
        name: {
            en: "Mongolia",
            de: "Mongolei",
        },
    },
    {
        id: "ME",
        name: {
            en: "Montenegro",
            de: "Montenegro",
        },
    },
    {
        id: "MS",
        name: {
            en: "Montserrat",
            de: "Montserrat",
        },
    },
    {
        id: "MA",
        name: {
            en: "Morocco",
            de: "Marokko",
        },
    },
    {
        id: "MZ",
        name: {
            en: "Mozambique",
            de: "Mosambik",
        },
    },
    {
        id: "MM",
        name: {
            en: "Myanmar",
            de: "Myanmar",
        },
    },
    {
        id: "NA",
        name: {
            en: "Namibia",
            de: "Namibia",
        },
    },
    {
        id: "NR",
        name: {
            en: "Nauru",
            de: "Nauru",
        },
    },
    {
        id: "NP",
        name: {
            en: "Nepal",
            de: "Nepal",
        },
    },
    {
        id: "NL",
        name: {
            en: "Netherlands",
            de: "Niederlande",
        },
    },
    {
        id: "NC",
        name: {
            en: "New Caledonia",
            de: "Neukaledonien",
        },
    },
    {
        id: "NZ",
        name: {
            en: "New Zealand",
            de: "Neuseeland",
        },
    },
    {
        id: "NI",
        name: {
            en: "Nicaragua",
            de: "Nicaragua",
        },
    },
    {
        id: "NE",
        name: {
            en: "Niger",
            de: "Niger",
        },
    },
    {
        id: "NG",
        name: {
            en: "Nigeria",
            de: "Nigeria",
        },
    },
    {
        id: "NU",
        name: {
            en: "Niue",
            de: "Niue",
        },
    },
    {
        id: "NF",
        name: {
            en: "Norfolk Island",
            de: "Norfolkinsel",
        },
    },
    {
        id: "KP",
        name: {
            en: "North Korea",
            de: "Nordkorea",
        },
    },
    {
        id: "MK",
        name: {
            en: "North Macedonia",
            de: "Nordmazedonien",
        },
    },
    {
        id: "MP",
        name: {
            en: "Northern Mariana Islands",
            de: "Nördliche Marianen",
        },
    },
    {
        id: "NO",
        name: {
            en: "Norway",
            de: "Norwegen",
        },
    },
    {
        id: "OM",
        name: {
            en: "Oman",
            de: "Oman",
        },
    },
    {
        id: "PK",
        name: {
            en: "Pakistan",
            de: "Pakistan",
        },
    },
    {
        id: "PW",
        name: {
            en: "Palau",
            de: "Palau",
        },
    },
    {
        id: "PS",
        name: {
            en: "Palestine",
            de: "Palästina",
        },
    },
    {
        id: "PA",
        name: {
            en: "Panama",
            de: "Panama",
        },
    },
    {
        id: "PG",
        name: {
            en: "Papua New Guinea",
            de: "Papua-Neuguinea",
        },
    },
    {
        id: "PY",
        name: {
            en: "Paraguay",
            de: "Paraguay",
        },
    },
    {
        id: "PE",
        name: {
            en: "Peru",
            de: "Peru",
        },
    },
    {
        id: "PH",
        name: {
            en: "Philippines",
            de: "Philippinen",
        },
    },
    {
        id: "PN",
        name: {
            en: "Pitcairn Islands",
            de: "Pitcairninseln",
        },
    },
    {
        id: "PL",
        name: {
            en: "Poland",
            de: "Polen",
        },
    },
    {
        id: "PT",
        name: {
            en: "Portugal",
            de: "Portugal",
        },
    },
    {
        id: "PR",
        name: {
            en: "Puerto Rico",
            de: "Puerto Rico",
        },
    },
    {
        id: "QA",
        name: {
            en: "Qatar",
            de: "Katar",
        },
    },
    {
        id: "CG",
        name: {
            en: "Republic of the Congo",
            de: "Kongo",
        },
    },
    {
        id: "RE",
        name: {
            en: "Réunion",
            de: "Réunion",
        },
    },
    {
        id: "RO",
        name: {
            en: "Romania",
            de: "Rumänien",
        },
    },
    {
        id: "RU",
        name: {
            en: "Russia",
            de: "Russland",
        },
    },
    {
        id: "RW",
        name: {
            en: "Rwanda",
            de: "Ruanda",
        },
    },
    {
        id: "BL",
        name: {
            en: "Saint Barthélemy",
            de: "Saint-Barthélemy",
        },
    },
    {
        id: "SH",
        name: {
            en: "Saint Helena, Ascension and Tristan da Cunha",
            de: "St. Helena, Ascension und Tristan da Cunha",
        },
    },
    {
        id: "KN",
        name: {
            en: "Saint Kitts and Nevis",
            de: "St. Kitts und Nevis",
        },
    },
    {
        id: "LC",
        name: {
            en: "Saint Lucia",
            de: "St. Lucia",
        },
    },
    {
        id: "MF",
        name: {
            en: "Saint Martin",
            de: "Saint-Martin",
        },
    },
    {
        id: "PM",
        name: {
            en: "Saint Pierre and Miquelon",
            de: "St. Pierre und Miquelon",
        },
    },
    {
        id: "VC",
        name: {
            en: "Saint Vincent and the Grenadines",
            de: "St. Vincent und die Grenadinen",
        },
    },
    {
        id: "WS",
        name: {
            en: "Samoa",
            de: "Samoa",
        },
    },
    {
        id: "SM",
        name: {
            en: "San Marino",
            de: "San Marino",
        },
    },
    {
        id: "ST",
        name: {
            en: "São Tomé and Príncipe",
            de: "São Tomé und Príncipe",
        },
    },
    {
        id: "SA",
        name: {
            en: "Saudi Arabia",
            de: "Saudi-Arabien",
        },
    },
    {
        id: "SN",
        name: {
            en: "Senegal",
            de: "Senegal",
        },
    },
    {
        id: "RS",
        name: {
            en: "Serbia",
            de: "Serbien",
        },
    },
    {
        id: "SC",
        name: {
            en: "Seychelles",
            de: "Seychellen",
        },
    },
    {
        id: "SL",
        name: {
            en: "Sierra Leone",
            de: "Sierra Leone",
        },
    },
    {
        id: "SG",
        name: {
            en: "Singapore",
            de: "Singapur",
        },
    },
    {
        id: "SX",
        name: {
            en: "Sint Maarten",
            de: "Sint Maarten",
        },
    },
    {
        id: "SK",
        name: {
            en: "Slovakia",
            de: "Slowakei",
        },
    },
    {
        id: "SI",
        name: {
            en: "Slovenia",
            de: "Slowenien",
        },
    },
    {
        id: "SB",
        name: {
            en: "Solomon Islands",
            de: "Salomonen",
        },
    },
    {
        id: "SO",
        name: {
            en: "Somalia",
            de: "Somalia",
        },
    },
    {
        id: "ZA",
        name: {
            en: "South Africa",
            de: "Südafrika",
        },
    },
    {
        id: "GS",
        name: {
            en: "South Georgia",
            de: "Südgeorgien und die Südlichen Sandwichinseln",
        },
    },
    {
        id: "KR",
        name: {
            en: "South Korea",
            de: "Südkorea",
        },
    },
    {
        id: "SS",
        name: {
            en: "South Sudan",
            de: "Südsudan",
        },
    },
    {
        id: "ES",
        name: {
            en: "Spain",
            de: "Spanien",
        },
    },
    {
        id: "LK",
        name: {
            en: "Sri Lanka",
            de: "Sri Lanka",
        },
    },
    {
        id: "SD",
        name: {
            en: "Sudan",
            de: "Sudan",
        },
    },
    {
        id: "SR",
        name: {
            en: "Suriname",
            de: "Suriname",
        },
    },
    {
        id: "SJ",
        name: {
            en: "Svalbard and Jan Mayen",
            de: "Spitzbergen und Jan Mayen",
        },
    },
    {
        id: "SE",
        name: {
            en: "Sweden",
            de: "Schweden",
        },
    },
    {
        id: "CH",
        name: {
            en: "Switzerland",
            de: "Schweiz",
        },
    },
    {
        id: "SY",
        name: {
            en: "Syria",
            de: "Syrien",
        },
    },
    {
        id: "TW",
        name: {
            en: "Taiwan",
            de: "Taiwan",
        },
    },
    {
        id: "TJ",
        name: {
            en: "Tajikistan",
            de: "Tadschikistan",
        },
    },
    {
        id: "TZ",
        name: {
            en: "Tanzania",
            de: "Tansania",
        },
    },
    {
        id: "TH",
        name: {
            en: "Thailand",
            de: "Thailand",
        },
    },
    {
        id: "TL",
        name: {
            en: "Timor-Leste",
            de: "Osttimor",
        },
    },
    {
        id: "TG",
        name: {
            en: "Togo",
            de: "Togo",
        },
    },
    {
        id: "TK",
        name: {
            en: "Tokelau",
            de: "Tokelau",
        },
    },
    {
        id: "TO",
        name: {
            en: "Tonga",
            de: "Tonga",
        },
    },
    {
        id: "TT",
        name: {
            en: "Trinidad and Tobago",
            de: "Trinidad und Tobago",
        },
    },
    {
        id: "TN",
        name: {
            en: "Tunisia",
            de: "Tunesien",
        },
    },
    {
        id: "TR",
        name: {
            en: "Turkey",
            de: "Türkei",
        },
    },
    {
        id: "TM",
        name: {
            en: "Turkmenistan",
            de: "Turkmenistan",
        },
    },
    {
        id: "TC",
        name: {
            en: "Turks and Caicos Islands",
            de: "Turks-und Caicosinseln",
        },
    },
    {
        id: "TV",
        name: {
            en: "Tuvalu",
            de: "Tuvalu",
        },
    },
    {
        id: "UG",
        name: {
            en: "Uganda",
            de: "Uganda",
        },
    },
    {
        id: "UA",
        name: {
            en: "Ukraine",
            de: "Ukraine",
        },
    },
    {
        id: "AE",
        name: {
            en: "United Arab Emirates",
            de: "Vereinigte Arabische Emirate",
        },
    },
    {
        id: "GB",
        name: {
            en: "United Kingdom",
            de: "Vereinigtes Königreich",
        },
    },
    {
        id: "US",
        name: {
            en: "United States",
            de: "Vereinigte Staaten",
        },
    },
    {
        id: "UM",
        name: {
            en: "United States Minor Outlying Islands",
            de: "Kleinere Inselbesitzungen der Vereinigten Staaten",
        },
    },
    {
        id: "VI",
        name: {
            en: "United States Virgin Islands",
            de: "Amerikanische Jungferninseln",
        },
    },
    {
        id: "UY",
        name: {
            en: "Uruguay",
            de: "Uruguay",
        },
    },
    {
        id: "UZ",
        name: {
            en: "Uzbekistan",
            de: "Usbekistan",
        },
    },
    {
        id: "VU",
        name: {
            en: "Vanuatu",
            de: "Vanuatu",
        },
    },
    {
        id: "VA",
        name: {
            en: "Vatican City",
            de: "Vatikanstadt",
        },
    },
    {
        id: "VE",
        name: {
            en: "Venezuela",
            de: "Venezuela",
        },
    },
    {
        id: "VN",
        name: {
            en: "Vietnam",
            de: "Vietnam",
        },
    },
    {
        id: "WF",
        name: {
            en: "Wallis and Futuna",
            de: "Wallis und Futuna",
        },
    },
    {
        id: "EH",
        name: {
            en: "Western Sahara",
            de: "Westsahara",
        },
    },
    {
        id: "YE",
        name: {
            en: "Yemen",
            de: "Jemen",
        },
    },
    {
        id: "ZM",
        name: {
            en: "Zambia",
            de: "Sambia",
        },
    },
    {
        id: "ZW",
        name: {
            en: "Zimbabwe",
            de: "Simbabwe",
        },
    },
];
